import { render, staticRenderFns } from "./bmhq.vue?vue&type=template&id=6be061a9&scoped=true"
import script from "./bmhq.vue?vue&type=script&lang=js"
export * from "./bmhq.vue?vue&type=script&lang=js"
import style0 from "./bmhq.vue?vue&type=style&index=0&id=6be061a9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6be061a9",
  null
  
)

export default component.exports